import type { WorkspaceMember as GraftWorkspaceMember } from '@graft/nuget-gc.webportals.workspaces'

import { MemberLevel, MemberStatus } from '../../enums'
import type { WorkspaceMember } from '../../types'

export async function workspaceMemberToObject(entity: GraftWorkspaceMember): Promise<WorkspaceMember> {
  const [userId, firstName, lastName, email, avatarUrl, level, projectsCount, invitationPending] = await Promise.all([
    entity.get_userId(),
    entity.get_firstName(),
    entity.get_lastName(),
    entity.get_email(),
    entity.get_avatarUrl(),
    entity.get_level(),
    entity.get_projectsCount(),
    entity.get_invitationPending(),
  ])

  const nameParts = [firstName, lastName].flatMap((s) => {
    const part = s?.trim()
    return part ? [part] : []
  })
  const name = nameParts.length ? nameParts.join(' ') : null
  const emailValue = email ?? ''
  const id = userId || emailValue || `workspace-member-${name ?? 'unknown'}`
  const role = level === MemberLevel.ADMIN ? MemberLevel.ADMIN : MemberLevel.DEVELOPER

  return {
    id,
    name,
    email: emailValue,
    avatarUrl: avatarUrl?.trim() || null,
    role,
    status: invitationPending ? MemberStatus.PENDING : MemberStatus.ACTIVE,
    lastSeen: null,
    projectIds: [],
    projectsCount,
  }
}
